// extracted by mini-css-extract-plugin
export var blink = "styles-module--blink--JORNn";
export var c_textarea = "styles-module--c_textarea--P+pza";
export var error = "styles-module--error--2Zjx0";
export var label = "styles-module--label--EJzIO";
export var textarea = "styles-module--textarea--yJmuV";